import "./GeneralExpressionOfInterest.module.css";
import Header from "@/reusable_sections/Header";
import EquipmentHero from "./sections/EquipmentHero";
import ValuesPillars from "./sections/ValuesPillars";
import TeamSection from "./sections/TeamSection";
import DetailsServiceReparationRoulettes from "./sections/DetailsServiceReparationRoulettes";
import Footer from "@/reusable_sections/Footer";
export default function GeneralExpressionOfInterestPage() {
  return <div>
      <Header />
      <EquipmentHero />
      <ValuesPillars />
      <TeamSection />
      <DetailsServiceReparationRoulettes />
      <Footer />
    </div>;
}